import { RFIconProps } from "../types";
import clsx from "clsx";

export default function CloseIcon(props: RFIconProps) {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={clsx(props.className || "w-6 h-6")}
			onClick={props.onClick}
			id={props.id}
		>
			<path
				d="M3.75 3.25L16.25 15.75"
				stroke="currentColor"
				strokeWidth={props.strokeWidth || 1.5}
				strokeLinecap="round"
			/>
			<path
				d="M16.25 3.25L3.75 15.75"
				stroke="currentColor"
				strokeWidth={props.strokeWidth || 1.5}
				strokeLinecap="round"
			/>
		</svg>
	);
}
